import { isSuperAdmin, getSuperAdminHomePath } from './superAdminAccess';

/** Set after /auth/register during signup; cleared after subscription payment / schedule step */
export const PENDING_SUBSCRIPTION_ONBOARDING_KEY = 'pending_subscription_onboarding';

export function hasAuthToken() {
  try {
    const t = localStorage.getItem('token');
    if (!t || t === 'null' || t === 'undefined') return false;
    const parsed = JSON.parse(t);
    return Boolean(parsed);
  } catch {
    return false;
  }
}

export function getStoredUserDetail() {
  try {
    const raw = localStorage.getItem('userDetail');
    if (!raw || raw === 'null') return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Default dashboard route after login (matches login redirect logic). */
export function getDashboardPath() {
  if (isSuperAdmin()) return getSuperAdminHomePath();
  const role = getStoredUserDetail()?.role;
  if (role === '1' || role === '2') return '/user/dashboard';
  return '/dashboard';
}
